var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeAndAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.42401 1.06905C5.57037 1.30322 5.49918 1.6117 5.26501 1.75805L2.59833 3.42472C2.36416 3.57107 2.05569 3.49988 1.90933 3.26572C1.76298 3.03154 1.83417 2.72307 2.06833 2.57672L4.73502 0.910051C4.96919 0.763698 5.27766 0.834884 5.42401 1.06905ZM10.576 1.06905C10.7223 0.834884 11.0308 0.763698 11.265 0.910051L13.9317 2.57672C14.1659 2.72307 14.237 3.03155 14.0907 3.26572C13.9443 3.49988 13.6359 3.57107 13.4017 3.42472L10.735 1.75805C10.5008 1.61169 10.4297 1.30322 10.576 1.06905ZM8 3.16738C4.96243 3.16738 2.5 5.62982 2.5 8.6674C2.5 11.7049 4.96243 14.1674 8 14.1674C11.0375 14.1674 13.5 11.7049 13.5 8.6674C13.5 5.62982 11.0375 3.16738 8 3.16738ZM1.5 8.6674C1.5 5.07753 4.41015 2.16738 8 2.16738C11.5899 2.16738 14.5 5.07753 14.5 8.6674C14.5 12.2573 11.5899 15.1674 8 15.1674C4.41015 15.1674 1.5 12.2573 1.5 8.6674ZM8 5.50072C8.27613 5.50072 8.5 5.72457 8.5 6.00072V8.46026L10.0202 9.98046C10.2155 10.1757 10.2155 10.4923 10.0202 10.6876C9.82493 10.8829 9.5084 10.8829 9.31313 10.6876L7.64647 9.02093C7.55267 8.9272 7.5 8.8 7.5 8.6674V6.00072C7.5 5.72457 7.72387 5.50072 8 5.50072Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAndAttendance);
export default __webpack_public_path__ + "static/media/time-and-attendance.6b1311cf6e3608db4dcdc250fde78244.svg";
export { ForwardRef as ReactComponent };